<template>
  <div>
    <router-link
      v-if="item.link"
      class="menu-popup__item text-decoration-none"
      :class="{ 'menu-popup__item--active': item.active }"
      :to="item.link(rowItem || item)"
    >
      <MenuPopupItemInsideContent :item="item" />
    </router-link>
    <div
      v-else
      class="menu-popup__item"
      :class="{ 'menu-popup__item--active': item.active }"
      @click.stop="item.click(rowItem || item)"
    >
      <MenuPopupItemInsideContent :item="item" />
    </div>
  </div>
</template>

<script>
import MenuPopupItemInsideContent from "./MenuPopupItemInsideContent.vue";
export default {
  components: { MenuPopupItemInsideContent },
  props: {
    item: {
      type: Object,
      default: null,
    },
    rowItem: {
      type: [Object, Number, String],
      default: null,
    },
  },
};
</script>
